import { render, staticRenderFns } from "./ConfigMenu.vue?vue&type=template&id=167ccefc&scoped=true&"
import script from "./ConfigMenu.vue?vue&type=script&lang=js&"
export * from "./ConfigMenu.vue?vue&type=script&lang=js&"
import style0 from "./ConfigMenu.vue?vue&type=style&index=0&id=167ccefc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ccefc",
  null
  
)

export default component.exports